import React from 'react'
import FormScenario from '../components/Form'
import hipladeTemplate from '../../common/template'

function ScenarioForm() {
  return <FormScenario />
}

export default hipladeTemplate(ScenarioForm)
